import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Gift, X, Copy, Check } from 'lucide-react';

const DISMISS_KEY = 'referral_cta_dismissed_at';
const DISMISS_TTL_MS = 24 * 60 * 60 * 1000;
const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

function isDismissed() {
  try {
    const ts = localStorage.getItem(DISMISS_KEY);
    if (!ts) return false;
    return Date.now() - parseInt(ts, 10) < DISMISS_TTL_MS;
  } catch {
    return false;
  }
}

export default function ReferralCTA() {
  const [hidden, setHidden] = useState(isDismissed);
  const [refLink, setRefLink] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (hidden) return;
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(`${API_BASE}/api/affiliate/my-code`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.ref_link) setRefLink(d.ref_link); })
      .catch(() => {});
  }, [hidden]);

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch {}
    setHidden(true);
  };

  const copyLink = () => {
    if (!refLink) return;
    navigator.clipboard.writeText(refLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  if (hidden) return null;

  return (
    <div className="mt-8 p-6 bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl text-white shadow-xl shadow-emerald-600/20 relative">
      <button
        onClick={dismiss}
        className="absolute top-3 right-3 p-1 rounded-full hover:bg-white/20 transition-colors"
        aria-label="Dismiss"
      >
        <X size={16} />
      </button>
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-xl bg-white/20 shrink-0 mt-0.5">
            <Gift size={20} />
          </div>
          <div>
            <h3 className="font-bold text-lg mb-1">Earn by referring friends</h3>
            <p className="text-emerald-100 text-sm">
              Get ₹200–₹1,000 per referral when they subscribe. Share your unique link below.
            </p>
            {refLink && (
              <div className="mt-2 flex items-center gap-2">
                <span className="text-xs font-mono bg-white/20 px-2 py-1 rounded-lg truncate max-w-xs">
                  {refLink}
                </span>
                <button
                  onClick={copyLink}
                  className="p-1.5 rounded-lg bg-white/20 hover:bg-white/30 transition-colors shrink-0"
                  title="Copy link"
                >
                  {copied ? <Check size={14} /> : <Copy size={14} />}
                </button>
              </div>
            )}
          </div>
        </div>
        <Link
          to="/referral"
          className="shrink-0 bg-white text-emerald-700 hover:bg-emerald-50 font-semibold px-5 py-2 rounded-full shadow-lg transition-all hover:-translate-y-0.5 text-sm whitespace-nowrap"
        >
          View Dashboard
        </Link>
      </div>
    </div>
  );
}
